export enum ProductHandlingMode {
	Default = 0,
	Recurring = 1,
	Charge = 2,
	Hide = 3,
	Show = 4,
	Grouped = 5,
	Ungrouped = 6
}
